import React, { Fragment, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import MenuItem from "@mui/material/MenuItem";
import { Card, CardBody, Container, Row } from "reactstrap";

import { Button } from "@mui/material";
import { Grid, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";

import { PersonSearch, Add, Refresh } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import CommonAccordion from "../../common/commonAccordion";
import CommonTable from "../../common/commonTable";
import {
  vendorEvaluationListTableData,
  vendorEvaluationListTableHeader,
} from "../../common/commonConstantAp";
import { useEffect } from "react";
import {
  getAllVendorEvaluationList,
  getAllVendorRegistrationList,
  searchVendorEvaluationListData,
} from "../../api/ap_services";
import CommonLoader from "../../common/commonLoader";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  btnClass: {
    padding: "0.5rem 1.5rem!important",
    fontWeight: 600,
  },

  btnJust: {
    display: "flex!important",
    justifyContent: "end!important",
  },

  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },

  muiGrid: {
    marginTop: "-2vh",
    [theme.breakpoints.down("sm")]: {
      lineHeight: 5,
    },
  },
}));

const status = [
  {
    value: "Y",
    label: "Active",
  },
  {
    value: "N",
    label: "In-Active",
  },
];

const VendorEvaluationList = () => {
  const history = useNavigate();
  const classes = useStyles();
  const [totalRecord, setTotalRecord] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const initialValues = {
    vendorEvaluationListId: null,
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vendorOptions, setVendorOptions] = useState([]);

  const filterInitialValues = {
    searchIsExistingUser: "",
    searchFactoryName: "",
    searchVendorCode: "",
  };
  const [searchData, setSearchData] = useState(filterInitialValues);

  const onFilterInputChange = (event) => {
    const { name, value } = event.target;
    searchData[name] = value;
    setSearchData({ ...searchData });
  };

  useEffect(() => {
    getAllVendorRegistrationList(0, 9999).then((res) => {
      const list = res?.response?.responseObject ?? [];
      const options = Array.isArray(list)
        ? list.map((item) => ({
            vendorCode: item.vendorCode ?? item.vendor_code ?? "",
            vendorName: item.companyName ?? item.company_name ?? "",
          }))
        : [];
      setVendorOptions(options);
    });
  }, []);

  useEffect(() => {
    loadListData();
  }, []);

  const loadListData = () => {
    setLoading(true);
    getAllVendorEvaluationList(page, rowsPerPage).then((res) => {
      setLoading(false);
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });
  };

  const redirectToVendorEvaluationForm = (data = initialValues) => {
    history(
      `${process.env.PUBLIC_URL}/master/vendorEvaluationForm/${data.vendorEvaluationListId}`,
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllVendorEvaluationList(newPage, rowsPerPage).then((res) => {
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    getAllVendorEvaluationList(0, event.target.value).then((res) => {
      setData(res.response.responseObject);
      setTotalRecord(res.response.responseMap.totalCount);
    });
  };

  // const onHandleSave = () => {
  //   setLoading(true);
  //   saveOrUpdateVendorEvaluationList(vendorEvaluationListData).then((res) => {
  //     if (vendorEvaluationListData.vendorEvaluationListId) {
  //       toast.success("Successfully Updated !", { autoClose: 1000 });
  //     } else {
  //       toast.success("Successfully Created !", { autoClose: 1000 });
  //     }
  //     setLoading(false);
  //     setOpen(false);
  //     setVendorEvaluationListData(initialValues);
  //     loadListData();
  //   });
  // };

  const filterData = () => {
    setLoading(true);
    searchVendorEvaluationListData(searchData, page, rowsPerPage).then(
      (res) => {
        setLoading(false);
        setData(res.responseMap.data);
      },
    );
  };

  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      <Breadcrumb
        title="Vendor Evaluation"
        parent={
          <div className={classes.btnJust}>
            <Button
              color={"secondary"}
              variant="contained"
              type="button"
              className={`${classes.btnClass}`}
              startIcon={<Add></Add>}
              onClick={() =>
                history(`${process.env.PUBLIC_URL}/master/vendorEvaluationForm`)
              }
            >
              Add Vendor Evaluation
            </Button>
          </div>
        }
      />
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
          <CommonAccordion accordionTitle={"Advanced Search"}>
            <Grid container columnSpacing={2} className={classes.muiGrid}>
              <Grid item sm={3} xs={12}>
                <TextField
                  fullWidth
                  id="outlined-select-currency"
                  select
                  label="Is existing user"
                  size="small"
                  name="searchIsExistingUser"
                  value={searchData.searchIsExistingUser}
                  onChange={onFilterInputChange}
                >
                  {status.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item sm={3} xs={12}>
                <TextField
                  fullWidth
                  label="Factory Name"
                  size="small"
                  id="fullWidth"
                  name="searchFactoryName"
                  value={searchData.searchFactoryName}
                  onChange={onFilterInputChange}
                />
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  fullWidth
                  label="Vendor Code"
                  size="small"
                  select
                  name="searchVendorCode"
                  value={searchData.searchVendorCode}
                  onChange={onFilterInputChange}
                >
                  <MenuItem value="">
                    <em>Select Vendor Code</em>
                  </MenuItem>
                  {vendorOptions.map((opt) => (
                    <MenuItem key={opt.vendorCode} value={opt.vendorCode}>
                      {opt.vendorCode} - {opt.vendorName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid
                item
                sm={3}
                xs={12}
                sx={{
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => filterData()}
                >
                  <PersonSearch></PersonSearch>
                </Button>
                <Button
                  color="primary"
                  sx={{ marginLeft: 1 }}
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => {
                    setSearchData(filterInitialValues);
                    loadListData();
                  }}
                >
                  <Refresh></Refresh>
                </Button>
              </Grid>
            </Grid>
          </CommonAccordion>
          <Card>
            <CardBody className={classes.cardbody}>
              <div>
                <CommonTable
                  tableData={data}
                  tableHeaders={vendorEvaluationListTableHeader}
                  tableColumns={vendorEvaluationListTableData}
                  editId={"vendorEvaluationListId"}
                  editMode={true}
                  onOpenModal={redirectToVendorEvaluationForm}
                  rowsPerPageOptions={[25, 50, 100]}
                  count={totalRecord}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{ float: "right" }}
                />
              </div>
            </CardBody>
          </Card>
        </Row>
      </Container>
      {/* <!-- Container-fluid Ends--> */}
      <ToastContainer autoClose={1000} />
    </Fragment>
  );
};

export default VendorEvaluationList;
